import React from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom';

import LandingPage from './elements/LandingPage/LandingPage';
import Home from '../src/elements/Home/Home'
import VideogameCreated from '../src/elements/CreateVideogame/CreateVideogame'
import Detail from './elements/Detail/Detail';

function App() {
  return (
    <BrowserRouter>
    <div className="App">
        <Routes>
          <Route path='/'element={<LandingPage/>}/>
          <Route path='/Home' element={<Home/>}/>
          <Route path='/videogame' element={<VideogameCreated/>}/>
          <Route path='/home/:id' element={<Detail/>}/>
        </Routes>
    </div>
    </BrowserRouter>
  );
}

export default App;
